import { Icon, IconProps } from './Icon';

interface UserIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const UserIcon = ({ color = '#BDC9EE', gradient, ...props }: UserIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 29 28"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      d="M14.5832 14.3027C16.18 14.3028 17.7612 14.6175 19.2365 15.2285C20.7119 15.8397 22.0526 16.736 23.1818 17.8652C24.311 18.9944 25.2064 20.3352 25.8175 21.8105C26.1952 22.7222 26.4597 23.6742 26.6066 24.6455C26.7573 25.6421 25.9261 26.4639 24.9181 26.4639H4.24722C3.23925 26.4639 2.40804 25.6421 2.55875 24.6455C2.70562 23.6743 2.97022 22.7222 3.34781 21.8105C3.95888 20.3353 4.85449 18.9944 5.98355 17.8652C7.11274 16.736 8.45352 15.8397 9.92886 15.2285C11.4043 14.6174 12.9862 14.3027 14.5832 14.3027ZM14.6886 1.8252C18.1343 1.8252 20.9279 4.61874 20.9279 8.06445C20.9278 11.5101 18.1343 14.3037 14.6886 14.3037C11.243 14.3037 8.4495 11.51 8.44937 8.06445C8.44937 4.61877 11.243 1.82524 14.6886 1.8252Z"
      fill={gradient ? `url(#${gradient.id})` : color}
    />
    <path
      d="M14.645 12.7756C15.1151 15.3277 17.112 17.3245 19.664 17.7946C17.112 18.2648 15.1151 20.2616 14.645 22.8137C14.1749 20.2616 12.178 18.2648 9.62598 17.7946C12.178 17.3245 14.1749 15.3277 14.645 12.7756Z"
      fill="#FEFEFE"
    />
  </Icon>
);
